<template>
  <component :is="icon" :question="question" :answer="answer" />
</template>

<script>
import InternetSpeedIcon from '@/components/icons/answer/InternetSpeedIcon'
import TransfersIcon from '@/components/icons/answer/TransfersIcon'
import TimeOfDayIcon from '@/components/icons/answer/TimeOfDayIcon'
import UserCountIcon from '@/components/icons/answer/UserCountIcon'
import TypeOfCallsIcon from '@/components/icons/answer/TypeOfCallsIcon'
import CallFeaturesIcon from '@/components/icons/answer/CallFeaturesIcon'
import PhoneLinesIcon from '@/components/icons/answer/PhoneLinesIcon'

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      iconTypes: {
        internet: InternetSpeedIcon,
        transfers: TransfersIcon,
        timeOfDay: TimeOfDayIcon,
        userCount: UserCountIcon,
        typeOfCalls: TypeOfCallsIcon,
        features: CallFeaturesIcon,
        lines: PhoneLinesIcon
      }
    }
  },

  computed: {
    icon () {
      return this.iconTypes[this.iconType]
    },

    iconType () {
      return this.question.icon.type
    }
  }
}
</script>
